import React from "react";
import Header from "../../../../layouts/AuthLayout/header/header";
import FormSection from "./form-section";

export default function AddAndEditBannerImagePage({
  isEdit,
}: {
  isEdit: boolean;
}) {
  return (
    <>
      <Header />
      <FormSection isEdit={isEdit} />
    </>
  );
}
